import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.patients');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-patients',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.patients/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PagePatientsComponent implements OnInit {
    public loading: boolean = false;
    public saving: boolean = false;
    public errorMessage: string = '';
    public patients: any[] = [];
    public total: number = 0;
    public currentYear: number = new Date().getFullYear();
    public traumaTypeDetailMaxLength: number = 80;
    public csrfToken: string = '';
    public canRequestErasure: boolean = false;
    public therapists: any[] = [];
    public currentUserId: string = '';
    public therapistSearch: string = '';
    public therapistMenuOpen: boolean = false;
    public formOptionsError: string = '';
    private loadSequence: number = 0;
    private formReturnFocus: HTMLElement | null = null;
    private deleteReturnFocus: HTMLElement | null = null;

    public search: any = {
        text: '',
        status: 'active',
        trauma_type: '',
        page: 1,
        dump: 20
    };

    public showFormModal: boolean = false;
    public form: any = this.emptyForm();
    public showDeleteModal: boolean = false;
    public deleteLoading: boolean = false;
    public deleting: boolean = false;
    public deleteTarget: any = null;
    public deletePreview: any = null;
    public deleteReason: string = 'retention_expired';
    public deleteConfirmation: string = '';
    private deleteIdempotencyKey: string = '';

    public genders: any[] = [
        { value: 'unspecified', label: '미응답' },
        { value: 'female', label: '여성' },
        { value: 'male', label: '남성' },
        { value: 'other', label: '기타' }
    ];

    public traumaTypes: any[] = [
        { value: 'traffic_accident', label: '교통사고' },
        { value: 'flight_related', label: '비행 관련' },
        { value: 'disaster_accident', label: '재난·사고' },
        { value: 'violence_crime', label: '폭력·범죄' },
        { value: 'loss_bereavement', label: '상실·사별' },
        { value: 'other', label: '기타' }
    ];

    public scenarioTypes: any[] = [
        { value: '', label: '미지정' }
    ];

    public erasureReasons: any[] = [
        { value: 'retention_expired', label: '보존 기한 만료' },
        { value: 'patient_request', label: '환자 요청' },
        { value: 'regulatory_request', label: '규제기관 요청' },
        { value: 'data_correction', label: '데이터 정정' },
        { value: 'other', label: '기타' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load(1);
        if (new URLSearchParams(window.location.search).get('create') === '1') {
            window.history.replaceState({}, '', window.location.pathname);
            await this.openCreate(false);
        }
    }

    public emptyForm() {
        return {
            id: '',
            patient_code: '',
            row_version: 1,
            birth_year: '',
            gender: 'unspecified',
            trauma_type: 'traffic_accident',
            trauma_type_detail: '',
            assigned_user_id: ''
        };
    }

    public message(data: any, fallback: string) {
        if (typeof data === 'string') return data;
        return data?.message || fallback;
    }

    public async load(page: number = this.search.page) {
        const sequence = ++this.loadSequence;
        this.loading = true;
        this.errorMessage = '';
        this.search.page = page;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('search', this.search);
            if (sequence !== this.loadSequence) return;
            if (code === 200) {
                this.patients = data.rows || [];
                this.total = data.total || 0;
                this.therapists = data.therapists || [];
                this.currentUserId = data.current_user_id || '';
                this.canRequestErasure = data.can_request_erasure === true;
                this.scenarioTypes = [
                    { value: '', label: '미지정' },
                    ...(data.scenario_options || [])
                ];
                this.formOptionsError = this.therapists.length > 0
                    ? ''
                    : '선택할 수 있는 담당 치료자가 없습니다.';
                this.csrfToken = data.csrf_token || '';
                const lastPage = Math.max(1, Math.ceil(this.total / this.search.dump));
                if (this.search.page > lastPage) {
                    await this.load(lastPage);
                }
                return;
            }
            this.errorMessage = this.message(data, '환자 목록을 불러오지 못했습니다.');
        } catch (error) {
            this.errorMessage = '환자 목록을 불러오지 못했습니다.';
        } finally {
            if (sequence !== this.loadSequence) return;
            this.loading = false;
            await this.service.render();
        }
    }

    public async resetFilters() {
        this.search = { text: '', status: 'active', trauma_type: '', page: 1, dump: 20 };
        await this.load(1);
    }

    public async openCreate(reloadOptions: boolean = true) {
        this.formReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        if (reloadOptions) await this.load(this.search.page);
        if (this.therapists.length === 0) {
            await this.service.modal.error(
                this.formOptionsError || '선택할 수 있는 담당 치료자가 없습니다.'
            );
            return;
        }
        this.form = this.emptyForm();
        this.form.assigned_user_id = this.currentUserId || this.therapists[0]?.id || '';
        this.therapistSearch = '';
        this.therapistMenuOpen = false;
        this.showFormModal = true;
        await this.service.render();
        document.getElementById('patient-birth-year')?.focus();
    }

    public async openEdit(patient: any) {
        this.formReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.form = {
            id: patient.id,
            patient_code: patient.patient_code,
            row_version: patient.row_version,
            birth_year: patient.birth_year || '',
            gender: patient.gender || 'unspecified',
            trauma_type: patient.trauma_type,
            trauma_type_detail: patient.trauma_type_detail || '',
            assigned_user_id: patient.assigned_user_id || this.currentUserId || ''
        };
        this.therapistSearch = '';
        this.therapistMenuOpen = false;
        this.showFormModal = true;
        await this.service.render();
        document.getElementById('patient-birth-year')?.focus();
    }

    public async openPatient(patient: any, event?: Event) {
        const target = event?.target;
        if (
            target instanceof Element
            && target.closest('button, a, input, select, textarea')
        ) return;
        const patientId = String(patient?.id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(patientId)) return;
        this.service.href(`/patients/${encodeURIComponent(patientId)}`);
    }

    public async closeForm() {
        if (this.saving) return;
        this.showFormModal = false;
        this.therapistMenuOpen = false;
        await this.service.render();
        const target = this.formReturnFocus;
        this.formReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onFormKeydown(event: KeyboardEvent) {
        if (event.key !== 'Tab') return;
        const dialog = document.getElementById('patient-form-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    @HostListener('document:keydown.escape')
    public async closeFormWithEscape() {
        if (this.showFormModal && !this.saving) await this.closeForm();
        else if (this.showDeleteModal && !this.deleting) await this.closeDelete();
    }

    public async openDelete(patient: any) {
        if (!this.canRequestErasure || this.deleteLoading || this.deleting) return;
        this.deleteReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.deleteTarget = patient;
        this.deletePreview = null;
        this.deleteReason = 'retention_expired';
        this.deleteConfirmation = '';
        this.deleteIdempotencyKey = '';
        this.showDeleteModal = true;
        this.deleteLoading = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('deletion_preview', { id: patient.id });
            if (code === 200 && data?.preview && data?.patient) {
                this.deleteTarget = { ...patient, ...data.patient };
                this.deletePreview = data.preview;
                return;
            }
            this.showDeleteModal = false;
            await this.service.modal.error(
                this.message(data, '삭제 사전 점검을 완료하지 못했습니다.')
            );
        } catch (error) {
            this.showDeleteModal = false;
            await this.service.modal.error('삭제 사전 점검을 완료하지 못했습니다.');
        } finally {
            this.deleteLoading = false;
            await this.service.render();
            if (this.showDeleteModal) {
                setTimeout(() => document.getElementById('patient-delete-dialog')?.focus(), 0);
            } else {
                const target = this.deleteReturnFocus;
                this.deleteReturnFocus = null;
                setTimeout(() => target?.focus(), 0);
            }
        }
    }

    public async closeDelete() {
        if (this.deleting) return;
        this.showDeleteModal = false;
        this.deleteTarget = null;
        this.deletePreview = null;
        this.deleteConfirmation = '';
        this.deleteIdempotencyKey = '';
        await this.service.render();
        const target = this.deleteReturnFocus;
        this.deleteReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onDeleteKeydown(event: KeyboardEvent) {
        if (event.key !== 'Tab') return;
        const dialog = document.getElementById('patient-delete-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public canSubmitDeletion() {
        return this.deletePreview?.eligible === true
            && !!this.deleteReason
            && this.deleteConfirmation.trim().toUpperCase()
                === String(this.deleteTarget?.patient_code || '').trim().toUpperCase()
            && !this.deleting;
    }

    public async requestDeletion() {
        if (!this.canSubmitDeletion()) return;
        if (!this.deleteIdempotencyKey) {
            try {
                const browserCrypto: any = (window as any).crypto;
                if (!browserCrypto || typeof browserCrypto.getRandomValues !== 'function') {
                    throw new Error('secure random unavailable');
                }
                const values = new Uint32Array(4);
                browserCrypto.getRandomValues(values);
                this.deleteIdempotencyKey = `ui:${Array.from(values)
                    .map((value: number) => value.toString(16).padStart(8, '0'))
                    .join('')}`;
            } catch (error) {
                await this.service.modal.error(
                    '안전한 요청 식별자를 만들 수 없어 삭제 요청을 중단했습니다.'
                );
                return;
            }
        }

        this.deleting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('request_deletion', {
                id: this.deleteTarget.id,
                expected_version: this.deleteTarget.row_version,
                reason_code: this.deleteReason,
                confirmation_code: this.deleteConfirmation,
                idempotency_key: this.deleteIdempotencyKey,
                csrf_token: this.csrfToken
            });
            if (code === 201) {
                this.showDeleteModal = false;
                this.deleteTarget = null;
                this.deletePreview = null;
                this.deleteConfirmation = '';
                this.deleteIdempotencyKey = '';
                await this.load(this.search.page);
                await this.service.modal.success(
                    '삭제 요청이 생성되었습니다. 다른 관리자가 운영 설정에서 승인해야 실제 삭제됩니다.'
                );
                return;
            }
            await this.service.modal.error(
                this.message(data, '삭제 요청을 생성하지 못했습니다.')
            );
            if (code === 409) await this.load(this.search.page);
        } catch (error) {
            await this.service.modal.error(
                '삭제 요청을 생성하지 못했습니다. 같은 요청으로 다시 시도할 수 있습니다.'
            );
        } finally {
            this.deleting = false;
            await this.service.render();
        }
    }

    public openGovernanceSettings() {
        this.service.href('/settings');
    }

    public blockerLabel(value: string) {
        const labels: any = {
            patient_not_archived: '환자를 먼저 보관해야 합니다.',
            retention_unset: '보존 기한이 설정되지 않았습니다.',
            retention_not_reached: '보존 기한이 아직 지나지 않았습니다.',
            legal_hold: '법적 보존이 적용되어 있습니다.',
            active_generation_jobs: '진행 중인 콘텐츠 생성 작업이 있습니다.',
            active_therapy_sessions: '진행 중인 치료 세션이 있습니다.'
        };
        return labels[value] || '삭제 차단 조건을 확인해주세요.';
    }

    public affectedDeletionCount() {
        const counts = this.deletePreview?.counts;
        if (!counts || typeof counts !== 'object') return 0;
        return Object.values(counts).reduce(
            (total: number, value: any) => total + Math.max(0, Number(value) || 0),
            0
        );
    }

    public async save() {
        if (this.saving) return;
        if (!this.form.assigned_user_id) {
            await this.service.modal.error('담당 치료자를 선택해주세요.');
            return;
        }
        if (!this.form.trauma_type) {
            await this.service.modal.error('외상 유형을 선택해주세요.');
            return;
        }
        const traumaTypeDetail = String(this.form.trauma_type_detail || '').trim();
        if (this.form.trauma_type === 'other' && !traumaTypeDetail) {
            await this.service.modal.error('기타 외상 유형을 입력해주세요.');
            return;
        }
        if (traumaTypeDetail.length > this.traumaTypeDetailMaxLength) {
            await this.service.modal.error('기타 외상 유형은 80자 이내로 입력해주세요.');
            return;
        }
        this.form.trauma_type_detail = this.form.trauma_type === 'other'
            ? traumaTypeDetail
            : '';

        if (this.form.birth_year && (Number(this.form.birth_year) < 1900 || Number(this.form.birth_year) > this.currentYear)) {
            await this.service.modal.error('출생연도를 확인해주세요.');
            return;
        }

        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', {
                ...this.form,
                expected_version: this.form.id ? this.form.row_version : '',
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                const created = !this.form.id;
                await this.service.modal.success(created ? '환자가 등록되었습니다.' : '환자 정보가 수정되었습니다.');
                this.showFormModal = false;
                const target = this.formReturnFocus;
                this.formReturnFocus = null;
                if (created && data?.patient?.id) {
                    this.service.href(
                        `/patients/${encodeURIComponent(data.patient.id)}?start=scenario`
                    );
                    return;
                }
                await this.load(this.search.page);
                setTimeout(() => target?.focus(), 0);
                return;
            }
            if (code === 409) {
                await this.service.modal.error(
                    this.message(
                        data,
                        '다른 사용자가 환자 정보를 수정했습니다. 목록을 새로고침한 뒤 다시 시도해주세요.'
                    )
                );
                await this.load(this.search.page);
                return;
            }
            await this.service.modal.error(this.message(data, '환자 정보를 저장하지 못했습니다.'));
        } catch (error) {
            await this.service.modal.error('환자 정보를 저장하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async toggleStatus(patient: any) {
        const nextStatus = patient.status === 'archived' ? 'active' : 'archived';
        const action = nextStatus === 'archived' ? '보관' : '활성화';
        const confirmed = await this.service.modal.show({
            title: `환자 ${action}`,
            message: `${patient.patient_code} 환자를 ${action}하시겠습니까?`,
            action: action,
            actionBtn: nextStatus === 'archived' ? 'error' : 'success',
            status: nextStatus === 'archived' ? 'error' : 'success'
        });
        if (!confirmed) return;

        try {
            const { code, data } = await wiz.call('set_status', {
                id: patient.id,
                status: nextStatus,
                expected_version: patient.row_version,
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                await this.load(this.search.page);
                return;
            }
            if (code === 409) {
                await this.service.modal.error(
                    this.message(
                        data,
                        '다른 사용자가 환자 상태를 변경했습니다. 최신 목록을 다시 불러옵니다.'
                    )
                );
                await this.load(this.search.page);
                return;
            }
            await this.service.modal.error(this.message(data, '환자 상태를 변경하지 못했습니다.'));
        } catch (error) {
            await this.service.modal.error('환자 상태를 변경하지 못했습니다.');
        }
    }

    public async onTraumaTypeChange(value: string) {
        this.form.trauma_type = value;
        if (value !== 'other') this.form.trauma_type_detail = '';
        await this.service.render();
        if (value === 'other') {
            setTimeout(() => document.getElementById('patient-trauma-type-detail')?.focus(), 0);
        }
    }

    public filteredTherapists() {
        const keyword = String(this.therapistSearch || '').trim().toLocaleLowerCase();
        if (!keyword) return this.therapists;
        return this.therapists.filter((therapist: any) => (
            `${therapist.name || ''} ${therapist.role || ''} ${this.roleLabel(therapist.role)}`
                .toLocaleLowerCase()
                .includes(keyword)
        ));
    }

    public selectedTherapist() {
        return this.therapists.find(
            (therapist: any) => therapist.id === this.form.assigned_user_id
        );
    }

    public roleLabel(role: string) {
        if (role === 'admin') return '관리자';
        if (role === 'therapist') return '담당 치료자';
        return '의료진';
    }

    public async toggleTherapistMenu() {
        this.therapistMenuOpen = !this.therapistMenuOpen;
        await this.service.render();
        if (this.therapistMenuOpen) {
            setTimeout(() => document.getElementById('patient-therapist-search')?.focus(), 0);
        }
    }

    public async selectTherapist(therapist: any) {
        this.form.assigned_user_id = therapist.id;
        this.therapistSearch = '';
        this.therapistMenuOpen = false;
        await this.service.render();
    }

    public traumaTypeLabel(patient: any) {
        if (patient?.trauma_type === 'other' && patient?.trauma_type_detail) {
            return patient.trauma_type_detail;
        }
        return this.labelOf(this.traumaTypes, patient?.trauma_type);
    }

    public labelOf(options: any[], value: string) {
        return options.find((item: any) => item.value === value)?.label || '미지정';
    }

    public statusLabel(status: string) {
        return status === 'archived' ? '보관' : '활성';
    }

    public statusClass(status: string) {
        return status === 'archived'
            ? 'bg-gray-100 text-gray-600 border border-gray-200'
            : 'bg-green-50 text-green-700 border border-green-200';
    }

    public ageBand(birthYear: any) {
        if (!birthYear) return '미입력';
        const age = Math.max(0, this.currentYear - Number(birthYear));
        if (age >= 100) return '100세 이상';
        if (age < 10) return '10세 미만';
        return `${Math.floor(age / 10) * 10}대`;
    }

    public get totalPages() {
        return Math.max(1, Math.ceil(this.total / this.search.dump));
    }
}

export default PagePatientsComponent;